import 'jquery';
import 'Vendor/fancybox/jquery.fancybox.min';
import 'Lib/font-load/font-load';
import 'Lib/js-anchor-link/js-anchor-link';
import 'Lib/touch-retina-to-html-tag/touch-retina-to-html-tag';
import 'Bem/site/checkbox-accept/checkbox-accept';
import 'Bem/site/ajax-form/ajax-form';
import 'Bem/site/img-loader/img-loader';
import { svgSpriteLoader } from 'Lib/svg-sprite-loader/svg-sprite-loader';
import 'imports-loader?wrapper=window!jquery-throttle-debounce'; // eslint-disable-line import/no-extraneous-dependencies, import/no-webpack-loader-syntax
import { onScreen } from 'Lib/on-screen/on-screen';

onScreen($('.suvorovoj-book__section'), ($el) => {
    $el.addClass('suvorovoj-book__section_visible');
}, 200, 200, 1.6);

// input file
let textInput = [];
const dropZone = document.querySelectorAll('.suvorovoj-book__screen7-btn-file');

$('.suvorovoj-book__screen7-form').on('eksmoThisAjaxFormSuccess', function () {
    const $this = $(this);

    $this.find('.suvorovoj-book__screen7-btn').addClass('btn_disabled').attr('disabled', 'true');
});

function createArrayNameFile(file, fileExtension) {
    if (file) {
        if ($.inArray(file.name.split('.').pop().toLowerCase(), fileExtension) === -1) {
            $.fancybox.open(`<div><p class="text text_c-gray">Недопустимый тип файла: ${file.name}</p></div>`);
        } else {
            const reader = new FileReader();

            reader.readAsDataURL(file);
            textInput.push(file.name);
        }
    }
}

dropZone.forEach((item) => {
    item.querySelector('.suvorovoj-book__manuscript-forms-item-input')?.addEventListener('change', (e) => {
        const target = e.target;
        const files = target.files;
        const elFileinput = item.querySelector('.suvorovoj-book__screen7-btn-text');

        textInput = [];

        if (item.classList.contains('suvorovoj-book__screen7-btn-file_text')) {
            Array.from(files).forEach((file) => createArrayNameFile(file, ['docx', 'pdf']));
        } else if (item.classList.contains('suvorovoj-book__screen7-btn-file_pic')) {
            Array.from(files).forEach((file) => createArrayNameFile(file, ['jpg', 'jpeg', 'png']));
        }

        if (textInput.length) {
            elFileinput.innerHTML = textInput.join(', ');
        }
    }, true);
});

svgSpriteLoader('/landing/suvorovoj-book/svg/sprite.svg?v=20181207');
